export default __webpack_public_path__ + "static/media/kr.b6392a9e.svg";